import Vue from 'vue'
import Router from 'vue-router'

// import { checkLogin } from '../util/index'

const leftBar = () =>
    import( /* webpackChunkName: "leftBar" */ '../components/LeftBar/index.vue');
const topBar = () =>
    import( /* webpackChunkName: "topBar" */ '../components/TopBar/index.vue');
const LoginView = () =>
    import( /* webpackChunkName: "LoginView" */ '../views/LoginView/index.vue');
const HomeView = () =>
    import( /* webpackChunkName: "HomeView" */ '../views/HomeView/index.vue');
const UserListView = () =>
    import( /* webpackChunkName: "UserListView" */ '../views/UserView/list.vue');
const UserInfoView = () =>
    import( /* webpackChunkName: "UserInfoView" */ '../views/UserView/info.vue');
const UserRecordView = () =>
    import( /* webpackChunkName: "UserRecordView" */ '../views/UserView/record.vue');
const UserRecordDetailView = () =>
    import( /* webpackChunkName: "UserRecordDetailView" */ '../views/UserView/detail.vue');
const CardListView = () =>
    import( /* webpackChunkName: "CardListView" */ '../views/CardManageView/list.vue');
const CardAddView = () =>
    import( /* webpackChunkName: "CardAddView" */ '../views/CardManageView/add.vue');
const CardManageView = () =>
    import( /* webpackChunkName: "CardManageView" */ '../views/CardManageView/index.vue');
const CardPackageView = () =>
    import( /* webpackChunkName: "CardPackageView" */ '../views/CardPackageView/index.vue');
const AppListView = () =>
    import( /* webpackChunkName: "AppListView" */ '../views/AppView/list.vue');
const AppInfoView = () =>
    import( /* webpackChunkName: "AppInfoView" */ '../views/AppView/info.vue');
const SubAdminListView = () =>
    import( /* webpackChunkName: "SubAdminListView" */ '../views/SubAdminView/list.vue');
const SubAdminInfoView = () =>
    import( /* webpackChunkName: "SubAdminInfoView" */ '../views/SubAdminView/info.vue');
const MachineListView = () =>
    import( /* webpackChunkName: "MachineListView" */ '../views/AppView/machine.vue');
const ConsumeView = () =>
    import( /* webpackChunkName: "ConsumeView" */ '../views/ConsumeView/index.vue');
const RecordView = () =>
    import( /* webpackChunkName: "RecordView" */ '../views/RecordView/index.vue');
const PrivilegeListView = () =>
    import( /* webpackChunkName: "PrivilegeListView" */ '../views/PrivilegeView/list.vue');
const HelpListView = () =>
    import( /* webpackChunkName: "HelpListView" */ '../views/HelpView/list.vue');
const HelpInfoView = () =>
    import( /* webpackChunkName: "HelpInfoView" */ '../views/HelpView/info.vue');
const SuperAdminIndexView = () =>
    import( /* webpackChunkName: "SuperAdminIndexView" */ '../views/SuperAdminView/index.vue');
const SuperAdminCardView = () =>
    import( /* webpackChunkName: "SuperAdminCardView" */ '../views/SuperAdminView/card.vue');
const SuperAdminSearchView = () =>
    import( /* webpackChunkName: "SuperAdminSearchView" */ '../views/SuperAdminView/search.vue');
const IndexInfoView = () =>
    import( /* webpackChunkName: "IndexInfoView" */ '../views/SuperAdminView/indexInfo.vue');
const CardInfoView = () =>
    import( /* webpackChunkName: "CardInfoView" */ '../views/SuperAdminView/cardInfo.vue');
const ReadMeView = () =>
    import( /* webpackChunkName: "ReadMeView" */ '../views/ReadMeView/index.vue');
const ManageView = () =>
    import( /* webpackChunkName: "ManageView" */ '../views/SuperAdminView/manage.vue');
const UserCardView = () =>
    import( /* webpackChunkName: "UserCardView" */ '../views/UserView/card.vue');
const EntityListView = () =>
    import( /* webpackChunkName: "EntityListView" */ '../views/EntityListView/list.vue');
const EntityIntroduceView = () =>
    import( /* webpackChunkName: "EntityIntroduceView" */ '../views/EntityListView/index.vue');
const EntityIntroduceListView = () =>
    import( /* webpackChunkName: "EntityIntroduceListView" */ '../views/EntityListView/introduceList.vue');
const SuperAdmiMenuView = () =>
    import( /* webpackChunkName: "SuperAdmiMenuView" */ '../views/SuperAdminView/menu.vue');
const SuperAdminMenuInfoView = () =>
    import( /* webpackChunkName: "SuperAdminMenuInfoView" */ '../views/SuperAdminView/menuInfo.vue');
const PhoneNameView = () =>
    import( /* webpackChunkName: "PhoneNameView" */ '../views/PhoneView/list.vue');
const PhoneNameInfoView = () =>
    import( /* webpackChunkName: "PhoneNameInfoView" */ '../views/PhoneView/info.vue');
const PhonePoolView = () =>
    import( /* webpackChunkName: "PhonePoolView" */ '../views/PhoneView/list_pool.vue');
const PhonePoolInfoView = () =>
    import( /* webpackChunkName: "PhonePoolInfoView" */ '../views/PhoneView/info_pool.vue');
const PhoneNumberView = () =>
    import( /* webpackChunkName: "PhoneNumberView" */ '../views/PhoneView/list_number.vue');
const PhoneNumberInfoView = () =>
    import( /* webpackChunkName: "PhoneNumberInfoView" */ '../views/PhoneView/info_number.vue');
const PhoneNumberRecordView = () =>
    import( /* webpackChunkName: "PhoneNumberRecordView" */ '../views/PhoneView/record.vue');
const PhoneNumberRecordDetailView = () =>
    import( /* webpackChunkName: "PhoneNumberRecordDetailView" */ '../views/PhoneView/detail.vue');
const Alik12manageView = () =>
    import( /* webpackChunkName: "Alik12manageView" */ '../views/SuperAdminView/alik12manage.vue');
const WechatmanageView = () =>
    import( /* webpackChunkName: "WechatmanageView" */ '../views/SuperAdminView/wechatmanage.vue');
const Wechatk12manageView = () =>
    import( /* webpackChunkName: "Wechatk12manageView" */ '../views/SuperAdminView/wechatk12manage.vue');
const AbnormalCardCollection = () =>
    import( /* webpackChunkName: "AbnormalCardCollection" */ '../views/AbnormalCardCollectionView/index.vue');
const AppletmanageView = () =>
    import( /* webpackChunkName: "AppletmanageView" */ '../views/SuperAdminView/appletmanage.vue');
const CardFaceView = () =>
    import( /* webpackChunkName: "CardFaceView" */ '../views/CardFaceView/index.vue');
const SuperAdminSwieprView = () =>
    import( /* webpackChunkName: "SuperAdminSwieprView" */ '../views/SuperAdminView/swiper.vue');
const SuperAdminSwieprIndexView = () =>
    import( /* webpackChunkName: "SuperAdminSwieprIndexView" */ '../views/SuperAdminView/swiperIndex.vue');
const SuperAdminSwieprVerifView = () =>
    import( /* webpackChunkName: "SuperAdminSwieprVerifView" */ '../views/SuperAdminView/verif.vue');
const SuperAdminExpireView = () =>
    import( /* webpackChunkName: "SuperAdminExpireView" */ '../views/SuperAdminView/expire.vue');
const SuperAdminNoticeView = () =>
    import( /* webpackChunkName: "SuperAdminNoticeView" */ '../views/SuperAdminView/notice.vue');
const SuperAdminNoticeAddView = () =>
    import( /* webpackChunkName: "SuperAdminNoticeAddView" */ '../views/SuperAdminView/noticeadd.vue');

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
        path: '/',
        redirect: to => {
            // 方法接收 目标路由 作为参数
            // return 重定向的 字符串路径/路径对象
            // console.log(to)
            // if (checkLogin()) {
            //     return { name: 'login' }
            // }
            return { name: 'home' }
        }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView
    },
    {
        path: '/home',
        name: 'home',
        components: {
            leftBar ,
            topBar,
            default: HomeView
        }
    },
    {
        path: '/user',
        name: 'user',
        components: {
            leftBar,
            topBar,
            default: UserListView
        }
    },
    {
        path: '/user/card',
        name: 'userCard',
        components: {
            leftBar,
            topBar,
            default: UserCardView
        }
    },
    {
        path: '/user/manage/:mode/:id?',
        name: "userInfo",
        props: true,
        components: {
            leftBar,
            topBar,
            default: UserInfoView
        }
    },
    {
        path: '/user/record/:mode',
        name: "userRecord",
        props: true,
        components: {
            leftBar,
            topBar,
            default: UserRecordView
        }
    },
    {
        path: '/user/record/detail/:id?',
        name: "userRecordDetail",
        props: true,
        components: {
            leftBar,
            topBar,
            default: UserRecordDetailView
        }
    },
    {
        path: '/phone',
        name: 'phone',
        redirect: to => {
            return { name: 'phoneName' }
        }
    },
    {
        path: '/phone/name',
        name: 'phoneName',
        components: {
            leftBar,
            topBar,
            default: PhoneNameView
        }
    },
    {
        path: '/phone/name/:mode/:id?',
        name: "phoneNameInfo",
        props: true,
        components: {
            leftBar,
            topBar,
            default: PhoneNameInfoView
        }
    },
    {
        path: '/phone/pool',
        name: 'phonePool',
        components: {
            leftBar,
            topBar,
            default: PhonePoolView
        }
    },
    {
        path: '/phone/pool/:mode/:id?',
        name: "phonePoolInfo",
        props: true,
        components: {
            leftBar,
            topBar,
            default: PhonePoolInfoView
        }
    },
    {
        path: '/phone/number',
        name: 'phoneNumber',
        components: {
            leftBar,
            topBar,
            default: PhoneNumberView
        }
    },
    {
        path: '/phone/number/:mode/:id?',
        name: "phoneNumberInfo",
        props: true,
        components: {
            leftBar,
            topBar,
            default: PhoneNumberInfoView
        }
    },
    {
        path: '/phone/record/:mode',
        name: "phoneNumberRecord",
        props: true,
        components: {
            leftBar,
            topBar,
            default: PhoneNumberRecordView
        }
    },
    {
        path: '/phone/record/detail/:id?',
        name: "phoneNumberRecordDetail",
        props: true,
        components: {
            leftBar,
            topBar,
            default: PhoneNumberRecordDetailView
        }
    },
    {
        path: '/abnormal',
        name: 'abnormal',
        components: {
            leftBar,
            topBar,
            default: AbnormalCardCollection
        }
    },
    {
        path: '/consume',
        name: "consume",
        props: true,
        components: {
            leftBar,
            topBar,
            default: ConsumeView
        }
    },
    {
        path: '/card',
        name: 'card',
        redirect: to => {
            return { name: 'cardList' }
        }
    },
    {
        path: '/card/manage',
        name: 'cardList',
        components: {
            leftBar,
            topBar,
            default: CardListView
        }
    },
    {
        path: '/card/manage/add',
        name: 'cardAdd',
        components: {
            leftBar,
            topBar,
            default: CardAddView
        }
    },
    {
        path: '/card/manage/:id/:activeTab?',
        name: 'cardManage',
        components: {
            leftBar,
            topBar,
            default: CardManageView
        }
    },
    {
        path: '/card/package/:activeTab?',
        name: 'cardPackage',
        components: {
            leftBar,
            topBar,
            default: CardPackageView
        }
    },
    {
        path: '/card/face/:activeTab?',
        name: 'cardFace',
        components: {
            leftBar,
            topBar,
            default: CardFaceView
        }
    },
    {
        path: '/pcard',
        name: 'entity',
        redirect: to => {
            return { name: 'entityList' }
        }
    },
    {
        path: '/pcard/manage',
        name: 'entityList',
        components: {
            leftBar,
            topBar,
            default: EntityListView
        }
    },
    {
        path: '/pcard/introduce',
        name: 'entityIntroduceList',
        components: {
            leftBar,
            topBar,
            default: EntityIntroduceListView
        }
    },
    {
        path: '/pcard/introduce/:mode/:id?',
        name: 'entityIntroduce',
        components: {
            leftBar,
            topBar,
            default: EntityIntroduceView
        }
    },
    {
        path: '/app',
        name: 'app',
        components: {
            leftBar,
            topBar,
            default: AppListView
        }
    },
    {
        path: '/app/machine/:appId',
        name: "machineList",
        props: true,
        components: {
            leftBar,
            topBar,
            default: MachineListView
        }
    },
    {
        path: '/app/:mode/:id?',
        name: "appInfo",
        props: true,
        components: {
            leftBar,
            topBar,
            default: AppInfoView
        }
    },
    {
        path: '/record',
        name: 'record',
        components: {
            leftBar,
            topBar,
            default: RecordView
        }
    },
    {
        path: '/privileges',
        name: 'privileges',
        components: {
            leftBar,
            topBar,
            default: PrivilegeListView
        }
    },
    {
        path: '/help',
        name: 'help',
        components: {
            leftBar,
            topBar,
            default: HelpListView
        }
    },
    {
        path: '/help/:mode/:id?',
        name: 'helpInfo',
        components: {
            leftBar,
            topBar,
            default: HelpInfoView
        }
    },
    {
        path: '/subadmin',
        name: 'subadmin',
        components: {
            leftBar,
            topBar,
            default: SubAdminListView
        }
    },
    {
        path: '/subadmin/:mode/:id?',
        name: 'subadminInfo',
        components: {
            leftBar,
            topBar,
            default: SubAdminInfoView
        }
    },
    {
        path: '/superadmin/login',
        name: 'superadminLogin',
        component: LoginView
    },
    {
        path: '/superadmin/index',
        name: 'index',
        components: {
            leftBar,
            topBar,
            default: SuperAdminIndexView
        }
    },
    {
        path: '/superadmin/index/:mode/:id?',
        name: 'indexInfo',
        components: {
            leftBar,
            topBar,
            default: IndexInfoView
        }
    },
    {
        path: '/superadmin/card',
        name: 'superCard',
        components: {
            leftBar,
            topBar,
            default: SuperAdminCardView
        }
    },
    {
        path: '/superadmin/search',
        name: 'search',
        components: {
            leftBar,
            topBar,
            default: SuperAdminSearchView
        }
    },
    {
        path: '/superadmin/card/:mode/:id?',
        name: 'cardInfo',
        components: {
            leftBar,
            topBar,
            default: CardInfoView
        }
    },
    {
        path: '/superadmin/manage/:id/:type?',
        name: 'manage',
        components: {
            leftBar,
            topBar,
            default: ManageView
        }
    },
    {
        path: '/superadmin/menu',
        name: 'menu',
        components: {
            leftBar,
            topBar,
            default: SuperAdmiMenuView
        }
    },
    {
        path: '/superadmin/menu/:mode/:id?',
        name: "menuInfo",
        props: true,
        components: {
            leftBar,
            topBar,
            default: SuperAdminMenuInfoView
        }
    },
    {
        path: '/superadmin/swiper/:mode/:id?',
        name: 'swiper',
        components: {
            leftBar,
            topBar,
            default: SuperAdminSwieprView
        }
    },
    {
        path: '/superadmin/swiper',
        name: 'swiperIndex',
        components: {
            leftBar,
            topBar,
            default: SuperAdminSwieprIndexView
        }
    },
    {
        path: '/superadmin/verif/:id',
        name: 'verif',
        components: {
            leftBar,
            topBar,
            default: SuperAdminSwieprVerifView
        }
    },
    {
        path: '/superadmin/alik12manage/:id',
        name: 'alik12manage',
        components: {
            leftBar,
            topBar,
            default: Alik12manageView
        }
    },
    {
        path: '/superadmin/wechatk12manage/:id',
        name: 'wechatk12manage',
        components: {
            leftBar,
            topBar,
            default: Wechatk12manageView
        }
    },
    {
        path: '/superadmin/appletmanage/:id',
        name: 'appletmanage',
        components: {
            leftBar,
            topBar,
            default: AppletmanageView
        }
    },
    {
        path: '/superadmin/wechatmanage/:id',
        name: 'wechatmanage',
        components: {
            leftBar,
            topBar,
            default: WechatmanageView
        }
    },
    {
        path: '/superadmin/expire',
        name: 'expire',
        components: {
            leftBar,
            topBar,
            default: SuperAdminExpireView
        }
    },
    {
        path: '/superadmin/notice',
        name: 'notice',
        components: {
            leftBar,
            topBar,
            default: SuperAdminNoticeView
        }
    },
    {
        path: '/superadmin/notice/:mode/:id?',
        name: 'noticeAdd',
        components: {
            leftBar,
            topBar,
            default: SuperAdminNoticeAddView
        }
    },
    {
        path: '/superadmin/',
        redirect: to => {
            // 方法接收 目标路由 作为参数
            // return 重定向的 字符串路径/路径对象
            // console.log(to)
            // if (checkLogin()) {
            //     return { name: 'login' }
            // }
            return { name: 'index' }
        }
    },
    {
        path: '/readme/:index?',
        name: 'readme',
        components: {
            leftBar,
            topBar,
            default: ReadMeView
        }
    },
    {
        path: '*',
        redirect: to => {
            return { name: 'home' }
        }
    }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js